/* ChillPaw interactions
   1. Product bubbles: press and drag one. Let go and it keeps sliding, slows
      against the water, lifts a little as it slows, bounces off the edges of
      its own section, knocks the other bubbles out of the way and cannot cross
      the marquee strip. A plain click still opens the product. Once its
      section is scrolled fully out of view, a moved bubble goes back home.
   2. Range rail: one row that scrolls, with arrows, edge fades and drag-to-scroll.
*/
(function () {
  'use strict';
  if (window.__cpInteractions) return;
  window.__cpInteractions = true;

  var BUBBLES = '.hbub__b, .tbub__b';
  var ORBS    = '.hbub__orb, .tbub__orb';
  var WALL    = '.mq';
  var THRESHOLD = 6;

  /* ---- water physics ---- */
  var FRICTION = 1.85;   /* velocity decay per second (higher = thicker water) */
  var BOUNCE   = 0.42;   /* energy kept when it hits a section edge or the strip */
  var HIT      = 0.72;   /* energy kept when two bubbles knock into each other */
  var LIFT     = 110;    /* px/s^2 of buoyancy pushing it upward */
  var LIFT_REF = 300;    /* speed at which buoyancy is at full strength */
  var STOP_V   = 7;      /* px/s: below this it has settled */
  var MAX_V    = 4000;   /* px/s cap so a violent flick stays sane */
  var EDGE_PAD = 8;
  var OVERLAP  = 0.96;   /* how close two bubbles may sit, as a share of their radii */

  function reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* ---------- shared frame loop ---------- */
  var all = [];      /* every bubble on the page, asleep or not */
  var live = [];     /* the ones this loop is currently animating */
  var ticking = false;
  var lastT = 0;
  var frameId = 0;

  function join(s) {
    if (live.indexOf(s) === -1) live.push(s);
    if (!ticking) {
      ticking = true;
      lastT = 0;
      requestAnimationFrame(tick);
    }
  }

  function leave(s) {
    var i = live.indexOf(s);
    if (i !== -1) live.splice(i, 1);
  }

  function tick(now) {
    if (!live.length) { ticking = false; return; }
    var dt = lastT ? (now - lastT) / 1000 : 0.016;
    lastT = now;
    if (dt > 0.05) dt = 0.05;          /* tab was backgrounded: don't teleport */
    frameId++;

    recall();

    var i;
    for (i = all.length - 1; i >= 0; i--) measure(all[i], now);
    for (i = live.length - 1; i >= 0; i--) integrate(live[i], dt, now);
    for (i = live.length - 1; i >= 0; i--) limit(live[i]);
    knock(now);
    for (i = live.length - 1; i >= 0; i--) settle(live[i]);
    for (i = live.length - 1; i >= 0; i--) paint(live[i]);

    requestAnimationFrame(tick);
  }

  /* ---------- geometry ---------- */
  function bob(s, now) {
    if (s.bobA === 0) return { x: 0, y: 0 };
    var t = (now / 1000) + s.phase;
    return {
      x: Math.sin(t * s.w1) * s.bobA * 0.55,
      y: Math.sin(t * s.w2 + 1.1) * s.bobA
    };
  }

  /* read where this bubble actually is on screen right now */
  function measure(s, now) {
    if (!s.el.isConnected) {
      var k = all.indexOf(s);
      if (k !== -1) all.splice(k, 1);
      leave(s);
      s.on = false;
      return;
    }
    var r = s.orb.getBoundingClientRect();
    if (!r.width || !r.height) { s.on = false; return; }
    s.on = true;
    s.rad = (r.width < r.height ? r.width : r.height) / 2;
    if (s.loose) {
      var b = bob(s, now);
      s.bx = b.x; s.by = b.y;
      s.hx = r.left + r.width / 2 - s.px;     /* home centre, transform removed */
      s.hy = r.top + r.height / 2 - s.py;
      s.cx = s.hx + s.x + s.bx;
      s.cy = s.hy + s.y + s.by;
    } else {
      s.bx = 0; s.by = 0;
      s.hx = s.cx = r.left + r.width / 2;
      s.hy = s.cy = r.top + r.height / 2;
    }
  }

  function move(s, dx, dy) {
    s.x += dx; s.y += dy;
    s.cx += dx; s.cy += dy;
  }

  function speedOf(s) { return Math.sqrt(s.vx * s.vx + s.vy * s.vy); }

  function cap(s) {
    var sp = speedOf(s);
    if (sp > MAX_V) { s.vx = s.vx / sp * MAX_V; s.vy = s.vy / sp * MAX_V; }
  }

  function kick(s) {
    if (s.dragging) return;
    if (speedOf(s) > STOP_V) {
      s.moving = true;
      s.el.classList.add('is-drifting');
      join(s);
    }
  }

  /* the marquee strip is a solid wall: nothing passes behind it */
  var wallEl = null, wallBox = null, wallStamp = -1;
  function wallRect() {
    if (wallStamp === frameId) return wallBox;
    wallStamp = frameId;
    if (!wallEl || !wallEl.isConnected) wallEl = document.querySelector(WALL);
    wallBox = wallEl ? wallEl.getBoundingClientRect() : null;
    if (wallBox && !wallBox.height) wallBox = null;
    return wallBox;
  }

  /* left/right screen edges, top/bottom of the bubble's own section, and the
     marquee strip. Bounding vertically by the section (not the screen) is what
     stops a moved bubble being dragged down the page as the shopper scrolls. */
  function limit(s) {
    if (!s.on || !s.loose) return;

    var sr = s.sec.getBoundingClientRect();
    var minX = EDGE_PAD + s.rad, maxX = window.innerWidth - EDGE_PAD - s.rad;
    var minY = sr.top + EDGE_PAD + s.rad, maxY = sr.bottom - EDGE_PAD - s.rad;
    if (maxX < minX) { minX = maxX = window.innerWidth / 2; }
    if (maxY < minY) { minY = maxY = (sr.top + sr.bottom) / 2; }

    if (s.cx < minX) { move(s, minX - s.cx, 0); if (!s.dragging && s.vx < 0) s.vx = -s.vx * BOUNCE; }
    else if (s.cx > maxX) { move(s, maxX - s.cx, 0); if (!s.dragging && s.vx > 0) s.vx = -s.vx * BOUNCE; }
    if (s.cy < minY) { move(s, 0, minY - s.cy); if (!s.dragging && s.vy < 0) s.vy = -s.vy * BOUNCE; }
    else if (s.cy > maxY) { move(s, 0, maxY - s.cy); if (!s.dragging && s.vy > 0) s.vy = -s.vy * BOUNCE; }

    var w = wallRect();
    if (!w) return;

    if (s.cy + s.rad <= w.top) s.side = -1;            /* sitting above the strip */
    else if (s.cy - s.rad >= w.bottom) s.side = 1;     /* sitting below it */
    else if (!s.side) s.side = s.cy < (w.top + w.bottom) / 2 ? -1 : 1;

    if (s.side < 0) {
      var top = w.top - s.rad;
      if (s.cy > top) { move(s, 0, top - s.cy); if (!s.dragging && s.vy > 0) s.vy = -s.vy * BOUNCE; }
    } else {
      var bot = w.bottom + s.rad;
      if (s.cy < bot) { move(s, 0, bot - s.cy); if (!s.dragging && s.vy < 0) s.vy = -s.vy * BOUNCE; }
    }
  }

  /* a moved bubble whose section is fully off screen goes back to its spot */
  function offscreen(sec) {
    var r = sec.getBoundingClientRect();
    return r.bottom <= 0 || r.top >= window.innerHeight;
  }

  function recall() {
    for (var i = all.length - 1; i >= 0; i--) {
      var s = all[i];
      if (s.loose && !s.dragging && s.el.isConnected && offscreen(s.sec)) sendHome(s.el);
    }
  }

  /* bubble against bubble */
  function knock(now) {
    for (var i = 0; i < all.length; i++) {
      var a = all[i];
      if (!a.on) continue;
      for (var j = i + 1; j < all.length; j++) {
        var b = all[j];
        if (!b.on) continue;
        if (!a.loose && !b.loose) continue;   /* two sleepers in their design spots */

        var dx = b.cx - a.cx, dy = b.cy - a.cy;
        var min = (a.rad + b.rad) * OVERLAP;
        var d2 = dx * dx + dy * dy;
        if (d2 >= min * min) continue;

        var d = Math.sqrt(d2);
        if (d < 0.01) { dx = 0; dy = -1; d = 0.01; } else { dx /= d; dy /= d; }

        if (!a.loose) wake(a, now);
        if (!b.loose) wake(b, now);

        var aFix = a.dragging, bFix = b.dragging;
        if (aFix && bFix) continue;

        var pen = min - d;
        var sa = aFix ? 0 : (bFix ? pen : pen / 2);
        var sb = pen - sa;
        if (sa) move(a, -dx * sa, -dy * sa);
        if (sb) move(b, dx * sb, dy * sb);

        var rvn = (b.vx - a.vx) * dx + (b.vy - a.vy) * dy;
        if (rvn < 0) {
          var imp = (aFix || bFix) ? -(1 + HIT) * rvn : -(1 + HIT) * rvn / 2;
          if (!aFix) { a.vx -= imp * dx; a.vy -= imp * dy; cap(a); kick(a); }
          if (!bFix) { b.vx += imp * dx; b.vy += imp * dy; cap(b); kick(b); }
        }

        limit(a); limit(b);
      }
    }
  }

  function integrate(s, dt, now) {
    if (s.dragging) {
      /* finger stopped moving: kill the stale throw velocity */
      if (now - s.stamp > 90) { s.vx = 0; s.vy = 0; }
      return;
    }
    if (!s.moving) return;

    var speed = speedOf(s);

    /* buoyancy: the faster it is travelling, the more the water lifts it */
    var lift = LIFT * Math.min(1, speed / LIFT_REF);
    s.vy -= lift * dt;

    /* water resistance */
    var damp = Math.exp(-FRICTION * dt);
    s.vx *= damp;
    s.vy *= damp;

    move(s, s.vx * dt, s.vy * dt);
  }

  function settle(s) {
    if (s.moving && speedOf(s) < STOP_V) {
      s.vx = 0; s.vy = 0; s.moving = false;
      s.el.classList.remove('is-drifting');
    }
    if (!s.moving && !s.dragging && s.bobA === 0) leave(s);
  }

  function paint(s) {
    s.px = s.x + s.bx;
    s.py = s.y + s.by;
    s.el.style.transform = 'translate3d(' + s.px + 'px,' + s.py + 'px,0)';
    s.el.setAttribute('data-cpx', s.x);
    s.el.setAttribute('data-cpy', s.y);
  }

  /* hand a bubble over from the CSS float to the physics, without it jumping */
  function wake(s, now) {
    if (s.loose) return;
    var before = s.orb.getBoundingClientRect();
    s.el.classList.add('is-loose');
    s.loose = true;
    s.bobA = reduced() ? 0 : (parseFloat(getComputedStyle(s.el).width) || 100) * 0.075;
    var after = s.orb.getBoundingClientRect();
    var b = bob(s, now || performance.now());
    s.bx = b.x; s.by = b.y;
    s.x = before.left - after.left - s.bx;
    s.y = before.top - after.top - s.by;
    s.hx = after.left + after.width / 2;
    s.hy = after.top + after.height / 2;
    s.rad = (after.width < after.height ? after.width : after.height) / 2;
    s.cx = s.hx + s.x + s.bx;
    s.cy = s.hy + s.y + s.by;
    s.on = true;
    paint(s);
    join(s);
  }

  function sendHome(el) {
    var s = el.__cp;
    if (s) {
      leave(s);
      s.x = 0; s.y = 0; s.vx = 0; s.vy = 0;
      s.px = 0; s.py = 0; s.bx = 0; s.by = 0;
      s.bobA = 0; s.side = 0;
      s.moving = false; s.dragging = false; s.loose = false;
    }
    el.classList.remove('is-loose', 'is-dragging', 'is-drifting');
    el.style.transform = '';
    el.removeAttribute('data-cpx');
    el.removeAttribute('data-cpy');
  }

  function makeDraggable(el) {
    if (el.getAttribute('data-cp-drag') === '1') return;
    el.setAttribute('data-cp-drag', '1');

    var dur = parseFloat(getComputedStyle(el).getPropertyValue('--hb-dur')) || 11;
    var off = Math.abs(parseFloat(getComputedStyle(el).getPropertyValue('--hb-delay')) || 0);

    var s = el.__cp = {
      el: el,
      orb: el.querySelector(ORBS) || el,
      sec: el.closest('section') || el.parentElement,
      x: 0, y: 0, vx: 0, vy: 0,
      px: 0, py: 0, bx: 0, by: 0,
      cx: 0, cy: 0, hx: 0, hy: 0, rad: 0,
      side: 0, on: false,
      dragging: false, moving: false, loose: false,
      stamp: 0,
      bobA: 0,
      phase: off,
      w1: (2 * Math.PI) / (dur * 1.7),
      w2: (2 * Math.PI) / dur
    };
    all.push(s);

    var pid = null;
    var startX = 0, startY = 0, baseX = 0, baseY = 0;
    var moved = false, blockClick = false, blockTimer = null;
    var lastX = 0, lastY = 0, lastMs = 0;

    Array.prototype.forEach.call(el.querySelectorAll('img'), function (img) { img.draggable = false; });
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });

    function begin(e) {
      moved = true;
      wake(s, performance.now());
      s.dragging = true;
      s.moving = false;
      s.vx = 0; s.vy = 0;
      s.stamp = performance.now();
      startX = lastX = e.clientX;
      startY = lastY = e.clientY;
      baseX = s.x; baseY = s.y;
      el.classList.add('is-dragging');
      document.documentElement.classList.add('cp-dragging');
      join(s);
    }

    el.addEventListener('pointerdown', function (e) {
      if (e.button && e.button !== 0) return;
      pid = e.pointerId;
      startX = lastX = e.clientX;
      startY = lastY = e.clientY;
      lastMs = e.timeStamp || performance.now();
      baseX = s.x; baseY = s.y;
      moved = false;
      try { el.setPointerCapture(pid); } catch (err) {}
    });

    el.addEventListener('pointermove', function (e) {
      if (pid === null || e.pointerId !== pid) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (!moved) {
        if (Math.abs(dx) < THRESHOLD && Math.abs(dy) < THRESHOLD) return;
        begin(e);
        dx = 0; dy = 0;
      }
      if (e.cancelable) e.preventDefault();

      var now = e.timeStamp || performance.now();
      var gap = now - lastMs;
      if (gap > 4) {
        /* smoothed pointer velocity, in px per second */
        var nvx = ((e.clientX - lastX) / gap) * 1000;
        var nvy = ((e.clientY - lastY) / gap) * 1000;
        s.vx = s.vx * 0.6 + nvx * 0.4;
        s.vy = s.vy * 0.6 + nvy * 0.4;
        lastX = e.clientX; lastY = e.clientY; lastMs = now;
        s.stamp = performance.now();
      }

      s.x = baseX + dx;
      s.y = baseY + dy;
      s.cx = s.hx + s.x + s.bx;
      s.cy = s.hy + s.y + s.by;
      limit(s);
      baseX = s.x - dx;
      baseY = s.y - dy;
    });

    function end(e) {
      if (pid === null || (e && e.pointerId !== pid)) return;
      try { el.releasePointerCapture(pid); } catch (err) {}
      pid = null;
      el.classList.remove('is-dragging');
      document.documentElement.classList.remove('cp-dragging');

      if (moved) {
        blockClick = true;
        clearTimeout(blockTimer);
        blockTimer = setTimeout(function () { blockClick = false; }, 400);

        s.dragging = false;
        /* stale pointer sample means the finger had stopped: no throw */
        var idle = (performance.now() - s.stamp) > 90;
        if (reduced() || idle) { s.vx = 0; s.vy = 0; }

        cap(s);
        if (speedOf(s) > STOP_V) { s.moving = true; el.classList.add('is-drifting'); }
        join(s);
      }
      moved = false;
    }

    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);

    el.addEventListener('click', function (e) {
      if (blockClick) {
        e.preventDefault();
        e.stopPropagation();
        blockClick = false;
      }
    }, true);

    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') sendHome(el);
    });
  }

  function initBubbles(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(BUBBLES), makeDraggable);
  }

  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return;
    lastW = window.innerWidth;
    Array.prototype.forEach.call(document.querySelectorAll('.is-loose'), sendHome);
  });

  /* covers bubbles that have settled and left the frame loop (reduced motion) */
  window.addEventListener('scroll', recall, { passive: true });

  /* Some browsers ignore scrollBy({behavior:'smooth'}), so animate it ourselves,
     with a plain jump as a fallback if frames never arrive. */
  function glide(el, delta) {
    var max = el.scrollWidth - el.clientWidth;
    var from = el.scrollLeft;
    var to = Math.min(Math.max(from + delta, 0), max);
    var dist = to - from;
    if (!dist) return;

    var id = (el.__cpGlide = (el.__cpGlide || 0) + 1);

    if (reduced() || document.hidden || !window.requestAnimationFrame) {
      el.scrollLeft = to;
      return;
    }

    var started = false;
    var t0 = performance.now();
    var dur = 420;

    function frame(now) {
      if (el.__cpGlide !== id) return;
      started = true;
      var p = Math.min(1, (now - t0) / dur);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      el.scrollLeft = from + dist * e;
      if (p < 1) requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
    setTimeout(function () {
      if (!started && el.__cpGlide === id) el.scrollLeft = to;
    }, 120);
  }

  function initRails(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-range-rail]'), function (rail) {
      if (rail.getAttribute('data-cp-rail') === '1') return;
      rail.setAttribute('data-cp-rail', '1');

      var track = rail.querySelector('[data-range-track]');
      if (!track) return;
      var prev = rail.querySelector('[data-range-prev]');
      var next = rail.querySelector('[data-range-next]');

      function step2() {
        var card = track.querySelector('.rcard');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var x = track.scrollLeft;
        rail.classList.toggle('is-scrollable', max > 4);
        rail.classList.toggle('at-start', x <= 2);
        rail.classList.toggle('at-end', x >= max - 2);
        if (prev) prev.disabled = x <= 2;
        if (next) next.disabled = x >= max - 2;
      }

      if (prev) prev.addEventListener('click', function () { glide(track, -step2()); });
      if (next) next.addEventListener('click', function () { glide(track, step2()); });

      track.addEventListener('scroll', function () { update(); }, { passive: true });
      window.addEventListener('resize', update);
      if (window.ResizeObserver) { new ResizeObserver(update).observe(track); }
      update();

      var down = false, sx = 0, sl = 0, dragged = false, rpid = null;

      function swallow(e) { e.preventDefault(); e.stopPropagation(); }

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        if (e.button && e.button !== 0) return;
        down = true; dragged = false; rpid = e.pointerId;
        sx = e.clientX; sl = track.scrollLeft;
      });

      track.addEventListener('pointermove', function (e) {
        if (!down || e.pointerId !== rpid) return;
        var dx = e.clientX - sx;
        if (!dragged) {
          if (Math.abs(dx) < THRESHOLD) return;
          dragged = true;
          track.__cpGlide = (track.__cpGlide || 0) + 1;
          track.classList.add('is-grabbing');
          try { track.setPointerCapture(rpid); } catch (err) {}
        }
        if (e.cancelable) e.preventDefault();
        track.scrollLeft = sl - dx;
      });

      function stopDrag() {
        if (!down) return;
        down = false;
        track.classList.remove('is-grabbing');
        try { track.releasePointerCapture(rpid); } catch (err) {}
        if (dragged) {
          track.addEventListener('click', swallow, true);
          setTimeout(function () { track.removeEventListener('click', swallow, true); }, 0);
        }
        dragged = false;
      }

      track.addEventListener('pointerup', stopDrag);
      track.addEventListener('pointercancel', stopDrag);
      track.addEventListener('pointerleave', stopDrag);
    });
  }

  function initAll(root) {
    initBubbles(root);
    initRails(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
